import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface PortalProps {
  title: string | undefined;
}

const HeaderPortal = ({ title }: PortalProps) => {
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById("Title-screen"));
  }, []);

  return (
    portalHeader &&
    ReactDOM.createPortal(
      <Typography
        variant="h3"
        sx={{
          display: "WebkitBox",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {title}
      </Typography>,
      portalHeader
    )
  );
};

export default HeaderPortal;
